module.exports = __webpack_public_path__ + "static/media/share.70bedac3.svg";